import graphql from 'babel-plugin-relay/macro';
import { SearchBar } from 'components/ui';
import { SEARCH_DELAY } from 'constant/timer';
import compose from 'lodash.flowright';
import PropType from 'prop-types';
import { useState } from 'react';
import { QueryRenderer } from 'react-relay';
import { withRouter } from 'react-router-dom';
import { useDebounce } from 'utils/hooks';
import { withGqlClient, withUser } from 'wrappers';

import LoadingState from '../loadingState';
import Collaborators from './collaborators';
import CollaboratorsHeader from './collaboratorsHeader';

const query = graphql`
  query collaboratorsRootQuery(
    $orgRowId: BigInt!
    $teamFilter: TeamFilter
    $collaboratorFilter: UserFilter
  ) {
    organizationByRowId(rowId: $orgRowId) {
      ...collaboratorsHeader_organization
      ...collaborators_organization
        @arguments(
          teamFilter: $teamFilter
          collaboratorFilter: $collaboratorFilter
        )
    }
  }
`;

export const Renderer = ({ error, props: data }) => {
  if (error) return <div>error!</div>;
  if (!data) return <LoadingState />;
  const { organizationByRowId } = data;
  return (
    <>
      <CollaboratorsHeader organization={organizationByRowId} />
      <Collaborators organization={organizationByRowId} />
    </>
  );
};

Renderer.propTypes = {
  error: PropType.object,
  props: PropType.object
};

Renderer.defaultProps = {
  error: undefined,
  props: undefined
};

export const CollaboratorsRoot = props => {
  const { environment, selectedOrganization, match } = props;
  const variables = {};

  const [char, setChar] = useState('');
  const search = useDebounce(char, SEARCH_DELAY);

  // There are some users that have unrealistic data so we need to account
  // for them to not crash the UI.
  if (!(selectedOrganization && selectedOrganization.rowId)) {
    return null;
  }
  const { rowId } = selectedOrganization;
  const organisationId = match.params.orgId || rowId;
  variables.orgRowId = organisationId;
  /* 
   Important teamfilter:
   We only want the count of the teams that the collaborator is a part of in this organization. 
   Otherwise, if a collaborator is a part of teams in multiple organizations we will get the wrong count.
  */
  variables.teamFilter = { organizationId: { equalTo: organisationId } };
  variables.collaboratorFilter = {
    or: [
      { name: { likeInsensitive: `%${search}%` } },
      { email: { likeInsensitive: `%${search}%` } }
    ]
  };

  const RendererWithRouter = withRouter(Renderer);

  return (
    <>
      <SearchBar label="Search Collaborators" search={char} setSearch={setChar}>
        <div id="btn-download-csv" />
      </SearchBar>

      <QueryRenderer
        environment={environment}
        query={query}
        render={RendererWithRouter}
        variables={variables}
      />
    </>
  );
};

CollaboratorsRoot.propTypes = {
  environment: PropType.object.isRequired,
  selectedOrganization: PropType.object
};

CollaboratorsRoot.defaultProps = {
  selectedOrganization: null
};

export default compose(withUser, withGqlClient)(CollaboratorsRoot);
